import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { Actor_ } from '../../../components/actor/Actor_';
export class SkeletonsMultiSelect extends SkeletonRegistryCategory {
    label = 'MultiSelect';
    constructor(parent) {
        super(parent);
        super.init();
    }
    MultiSelectStructure_base = () => new SkeletonRegistryItem({
        label: 'MultiSelect Structure base',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.questionPart })));
        },
    });
    MultiSelectOptionsOfCurrentStep = () => new SkeletonRegistryItem({
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            if (!question_.task)
                return null;
            return (React.createElement(Aspect_, { aspect: question_.ownAspect.options }, question_.task.shuffledOptions.map(option => React.createElement(Actor_, { actor: option, key: option.id }))));
        },
    });
    multiSelectNthGapFill = () => new SkeletonRegistryItem({
        label: 'Gap Fill with correct multi select solution',
        jsx: ({ at, questionMultiSelect, gap }) => {
            if (!questionMultiSelect || !gap)
                return null;
            const tagName = at.actor.tags.find(role => role.includes('task'));
            if (!tagName)
                return false;
            const nth = parseInt(tagName.split('task')[1]);
            if (questionMultiSelect.tasks.length < nth)
                return null;
            const option = questionMultiSelect.tasks[nth - 1].correctOption;
            if (!option)
                return null;
            if (at.trait.local.valueOf.contentFillType === 'textBasis') {
                return option.actorContent.local.firstTextBasis;
            }
            return React.createElement(Actor_, { actor: option, key: option.tid });
        },
        params: { core: ['contentFillType'] },
    });
}
